import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9cc32b62"
import script from "./unitArea.js?vue&type=script&lang=js&external"
export * from "./unitArea.js?vue&type=script&lang=js&external"
import style0 from "./unitArea.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports